const TeamSchema = (props) => ({
  title: 'AgSUS Equipe',
  fieldsets: [
    {
      id: 'default',
      title: 'Seção',
      fields: ['eyebrow', 'title', 'columns', 'variant'],
    },
    { id: 'items', title: 'Pessoas', fields: ['items'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título da seção' },
    columns: {
      title: 'Colunas',
      choices: [
        ['2', '2'],
        ['3', '3'],
        ['4', '4 (padrão)'],
      ],
      default: '4',
    },
    variant: {
      title: 'Fundo da seção',
      choices: [
        ['default', 'Paper (branco)'],
        ['alt', 'Surface (off-white)'],
      ],
      default: 'default',
    },
    items: {
      title: 'Pessoas',
      description: 'Cada pessoa tem foto (URL), nome, cargo e bio opcional.',
      widget: 'object_list',
      schema: {
        title: 'Pessoa',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['name', 'role', 'avatar', 'bio'],
          },
        ],
        properties: {
          name: { title: 'Nome' },
          role: { title: 'Cargo / função' },
          avatar: {
            title: 'Foto (URL)',
            description:
              'URL da imagem (interna do Plone ou externa). Se vazio, usa gradiente DS.',
          },
          bio: {
            title: 'Bio (opcional)',
            widget: 'textarea',
          },
        },
        required: ['name'],
      },
    },
  },
  required: [],
});

export default TeamSchema;
